module.exports = __webpack_public_path__ + "static/media/GAOFEN 1.18c41a90.czml";